(function (global) {
  'use strict';

  var FLOWER = 'flower';
  var VEIL = 'veil';
  var PROPERTY_KEY = '_luna_free_gift';
  var TIER_PROPERTY_KEY = '_luna_gift_tier';

  function managedType(item) {
    return item && item.properties ? item.properties[PROPERTY_KEY] || '' : '';
  }

  function normalizedTitle(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function computeEligibleCents(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var flowerVariantId = String((config && config.flowerVariantId) || '');
    var veilVariantId = String((config && config.veilVariantId) || '');

    return items.reduce(function (total, item) {
      if (managedType(item)) return total;
      if (String(item.variant_id || item.id || '') === flowerVariantId) return total;
      if (String(item.variant_id || item.id || '') === veilVariantId) return total;

      var title = normalizedTitle(item.product_title || item.title || '');
      if (title.indexOf('atma gelin cicegi') !== -1) return total;
      if (title.indexOf('duz tul kristal islemeli gelin duvagi') !== -1) return total;

      var linePrice = Number(item.original_line_price);
      if (!Number.isFinite(linePrice)) linePrice = Number(item.final_line_price);
      if (!Number.isFinite(linePrice)) linePrice = Number(item.line_price);
      return total + (Number.isFinite(linePrice) ? Math.max(0, linePrice) : 0);
    }, 0);
  }

  function computeGiftPlan(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var eligibleCents = Number(config && config.eligibleCents) || 0;
    var flowerThreshold = Number(config && config.flowerThreshold) || 350000;
    var veilThreshold = Number(config && config.veilThreshold) || 600000;
    var desired = {
      flower: eligibleCents >= flowerThreshold && Boolean(config && config.flowerAvailable && config.flowerVariantId),
      veil: eligibleCents >= veilThreshold && Boolean(config && config.veilAvailable && config.veilVariantId)
    };
    var variants = {
      flower: String((config && config.flowerVariantId) || ''),
      veil: String((config && config.veilVariantId) || '')
    };
    var thresholds = { flower: flowerThreshold, veil: veilThreshold };
    var lines = { flower: [], veil: [] };
    var updates = {};
    var additions = [];

    items.forEach(function (item) {
      var type = managedType(item);
      if (type === FLOWER || type === VEIL) lines[type].push(item);
    });

    [FLOWER, VEIL].forEach(function (type) {
      var typeLines = lines[type];
      if (!desired[type]) {
        typeLines.forEach(function (item) { updates[item.key] = 0; });
        return;
      }

      if (typeLines.length === 0) {
        additions.push({
          id: Number(variants[type]),
          quantity: 1,
          properties: (function () {
            var properties = {};
            properties[PROPERTY_KEY] = type;
            properties[TIER_PROPERTY_KEY] = String(Math.round(thresholds[type] / 100));
            return properties;
          })()
        });
        return;
      }

      typeLines.forEach(function (item, index) {
        if (index > 0) {
          updates[item.key] = 0;
        } else if (Number(item.quantity) !== 1 || String(item.variant_id) !== variants[type]) {
          updates[item.key] = String(item.variant_id) === variants[type] ? 1 : 0;
          if (String(item.variant_id) !== variants[type]) {
            additions.push({
              id: Number(variants[type]),
              quantity: 1,
              properties: (function () {
                var properties = {};
                properties[PROPERTY_KEY] = type;
                properties[TIER_PROPERTY_KEY] = String(Math.round(thresholds[type] / 100));
                return properties;
              })()
            });
          }
        }
      });
    });

    return {
      desired: desired,
      additions: additions,
      updates: updates,
      hasChanges: additions.length > 0 || Object.keys(updates).length > 0
    };
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { computeGiftPlan: computeGiftPlan, computeEligibleCents: computeEligibleCents };
  }

  if (!global || !global.document) return;
  if (global.__lunaFreeGiftControllerLoaded) return;
  global.__lunaFreeGiftControllerLoaded = true;

  var document = global.document;
  var root = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
  var syncTimer = null;
  var syncing = false;
  var rerunRequested = false;
  var lastCart = null;
  var checkoutPending = false;

  function toBoolean(value) {
    return String(value) === 'true';
  }

  function statePriority(context) {
    return { drawer: 4, cart: 3, product: 2, home: 1, general: 0 }[context] || 0;
  }

  function getStateCard() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-luna-gift-state]'))
      .filter(function (card) { return card.isConnected; })
      .sort(function (a, b) {
        return statePriority(b.dataset.lunaGiftContext) - statePriority(a.dataset.lunaGiftContext);
      })[0] || null;
  }

  function readConfig() {
    var card = getStateCard();
    if (!card) return null;
    return {
      eligibleCents: Number(card.dataset.lunaEligibleTotal || 0),
      flowerThreshold: Number(card.dataset.lunaAtmaThreshold || 350000),
      veilThreshold: Number(card.dataset.lunaVeilThreshold || 600000),
      flowerVariantId: String(card.dataset.lunaAtmaVariant || ''),
      flowerAvailable: toBoolean(card.dataset.lunaAtmaAvailable),
      flowerTitle: card.dataset.lunaAtmaTitle || 'Atma çiçeği',
      flowerImage: card.dataset.lunaAtmaImage || '',
      veilVariantId: String(card.dataset.lunaVeilVariant || ''),
      veilAvailable: toBoolean(card.dataset.lunaVeilAvailable),
      veilTitle: card.dataset.lunaVeilTitle || 'Kristal işlemeli duvak',
      veilImage: card.dataset.lunaVeilImage || ''
    };
  }

  function formatMoney(cents) {
    var value = Math.max(0, Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(value) + ' TL';
    } catch (error) {
      return Math.round(value) + ' TL';
    }
  }

  function updateProgressCards(config, cart) {
    if (!config) return;
    document.querySelectorAll('[data-luna-gift-state]').forEach(function (card) {
      var total = Number(config.eligibleCents || 0);
      var flowerUnlocked = total >= config.flowerThreshold;
      var veilUnlocked = total >= config.veilThreshold;
      var remaining = Math.max(0, (flowerUnlocked ? config.veilThreshold : config.flowerThreshold) - total);
      var progress = Math.min(100, Math.max(0, Math.round((total / config.veilThreshold) * 100)));
      var title = card.querySelector('[data-bayrak-gift-title]');
      var bar = card.querySelector('[data-bayrak-gift-bar]');
      var flowerTier = card.querySelector('[data-bayrak-atma-tier]');
      var veilTier = card.querySelector('[data-bayrak-veil-tier]');
      var flowerState = card.querySelector('[data-bayrak-atma-state]');
      var veilState = card.querySelector('[data-bayrak-veil-state]');

      card.dataset.lunaEligibleTotal = String(total);
      card.classList.remove('is-sync-error');
      card.classList.toggle('is-atma-unlocked', flowerUnlocked);
      card.classList.toggle('is-veil-unlocked', veilUnlocked);
      if (flowerTier) flowerTier.classList.toggle('is-unlocked', flowerUnlocked);
      if (veilTier) veilTier.classList.toggle('is-unlocked', veilUnlocked);
      if (flowerState) flowerState.textContent = flowerUnlocked ? '✓' : '1';
      if (veilState) veilState.textContent = veilUnlocked ? '✓' : '2';
      if (bar) bar.style.width = progress + '%';
      if (!title) return;
      if (veilUnlocked) title.textContent = 'Çiçek ve duvak hediyesi';
      else if (flowerUnlocked) title.textContent = 'Duvak hediyesi için ' + formatMoney(remaining) + ' kaldı.';
      else title.textContent = 'Atma çiçeği hediyesi için ' + formatMoney(remaining) + ' kaldı.';
    });
    document.dispatchEvent(new CustomEvent('luna-gifts:state', { detail: { config: config, cart: cart } }));
  }

  function showSyncError(message) {
    document.querySelectorAll('[data-luna-gift-state]').forEach(function (card) {
      card.classList.add('is-sync-error');
      var title = card.querySelector('[data-bayrak-gift-title]');
      if (title) title.textContent = message;
    });
  }

  function collectSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));
    return sections.filter(function (section, index) {
      return section && sections.indexOf(section) === index;
    });
  }

  async function fetchCart() {
    var response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Sepet okunamadı.');
    return response.json();
  }

  async function updateLines(updates) {
    var sections = collectSections();
    var response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: sections.join(','),
        sections_url: global.location.pathname
      })
    });
    var payload = await response.json();
    if (!response.ok) throw new Error(payload.description || payload.message || 'Hediye adedi güncellenemedi.');
    return payload;
  }

  async function addItems(items) {
    var sections = collectSections();
    var response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: items,
        sections: sections.join(','),
        sections_url: global.location.pathname
      })
    });
    var payload = await response.json();
    if (!response.ok) throw new Error(payload.description || payload.message || 'Hediye sepete eklenemedi.');
    var cart = await fetchCart();
    cart.sections = payload.sections || {};
    return cart;
  }

  function dispatchCartChange(cart, baseEvent) {
    lastCart = cart;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: baseEvent || 'luna-gift:change', cart: cart }
    }));
  }

  function announce(message) {
    var status = document.getElementById('status-announcement');
    if (status) status.textContent = message;
  }

  function pulseCart() {
    var cartLink = document.querySelector('a[href="' + root + 'cart"], a[href$="/cart"], .header__cart-link');
    if (!cartLink) return;
    cartLink.classList.remove('luna-cart-glow');
    global.requestAnimationFrame(function () { cartLink.classList.add('luna-cart-glow'); });
    global.setTimeout(function () { cartLink.classList.remove('luna-cart-glow'); }, 1100);
  }

  function giftDetails(types, config) {
    return types.map(function (type) {
      return type === FLOWER
        ? { type: type, title: config.flowerTitle, image: config.flowerImage }
        : { type: type, title: config.veilTitle, image: config.veilImage };
    });
  }

  function removeCelebration(element) {
    if (!element) return;
    element.classList.remove('is-visible');
    global.setTimeout(function () { if (element.parentNode) element.parentNode.removeChild(element); }, 320);
  }

  function showCelebration(types, config) {
    if (!types || !types.length || !config) return;
    var existing = document.querySelector('.luna-gift-celebration');
    if (existing) removeCelebration(existing);

    var gifts = giftDetails(types, config);
    var wrapper = document.createElement('div');
    var surface = document.createElement('div');
    var media = document.createElement('div');
    var copy = document.createElement('div');
    var eyebrow = document.createElement('p');
    var title = document.createElement('p');
    var text = document.createElement('p');
    var action = document.createElement('a');
    var close = document.createElement('button');
    var particles = document.createElement('div');

    wrapper.className = 'luna-gift-celebration';
    wrapper.setAttribute('role', 'status');
    wrapper.setAttribute('aria-live', 'polite');
    surface.className = 'luna-gift-celebration__surface';
    media.className = 'luna-gift-celebration__media';
    copy.className = 'luna-gift-celebration__copy';
    eyebrow.className = 'luna-gift-celebration__eyebrow';
    title.className = 'luna-gift-celebration__title';
    text.className = 'luna-gift-celebration__text';
    action.className = 'luna-gift-celebration__action';
    close.className = 'luna-gift-celebration__close';
    particles.className = 'luna-gift-celebration__particles';

    eyebrow.textContent = 'Bayrak’tan sana';
    title.textContent = gifts.length > 1 ? 'İki hediyen sepette ✨' : 'Hediyen sepette ✨';
    text.textContent = gifts.length > 1
      ? 'Atma çiçeğin ve kristal işlemeli duvağın bizden.'
      : (gifts[0].type === FLOWER ? 'Atma çiçeğin otomatik eklendi; bu özel gün hediyemiz.' : 'Kristal işlemeli duvağın otomatik eklendi; bu özel gün hediyemiz.');
    action.textContent = 'Sepeti gör';
    action.href = root + 'cart';
    close.type = 'button';
    close.setAttribute('aria-label', 'Bildirimi kapat');
    close.textContent = '×';

    gifts.forEach(function (gift) {
      if (!gift.image) return;
      var image = document.createElement('img');
      image.className = 'luna-gift-celebration__image';
      image.src = gift.image;
      image.alt = '';
      image.width = 62;
      image.height = 62;
      media.appendChild(image);
    });

    for (var index = 0; index < 14; index += 1) {
      var particle = document.createElement('span');
      var angle = (Math.PI * 2 * index) / 14;
      var distance = 72 + (index % 4) * 15;
      particle.className = 'luna-gift-celebration__particle';
      particle.style.setProperty('--particle-x', Math.round(Math.cos(angle) * distance) + 'px');
      particle.style.setProperty('--particle-y', Math.round(Math.sin(angle) * distance * 0.58) + 'px');
      particle.style.setProperty('--particle-delay', (index % 5) * 35 + 'ms');
      particles.appendChild(particle);
    }

    copy.appendChild(eyebrow);
    copy.appendChild(title);
    copy.appendChild(text);
    surface.appendChild(media);
    surface.appendChild(copy);
    surface.appendChild(action);
    surface.appendChild(close);
    wrapper.appendChild(surface);
    wrapper.appendChild(particles);
    document.body.appendChild(wrapper);

    var openDrawer = document.querySelector('cart-drawer[open]');
    if (openDrawer && global.matchMedia('(min-width: 700px)').matches) {
      var drawerRect = openDrawer.getBoundingClientRect();
      if (drawerRect.left > wrapper.offsetWidth + 40) {
        wrapper.style.left = Math.round(drawerRect.left / 2) + 'px';
      }
    }

    close.addEventListener('click', function () { removeCelebration(wrapper); });
    global.requestAnimationFrame(function () {
      global.requestAnimationFrame(function () { wrapper.classList.add('is-visible'); });
    });
    global.setTimeout(function () { removeCelebration(wrapper); }, 5600);
    pulseCart();
    announce(title.textContent + ' ' + text.textContent);
  }

  function persistCelebration(types) {
    try { global.sessionStorage.setItem('lunaGiftCelebration', JSON.stringify(types)); } catch (error) {}
  }

  function consumeCelebration() {
    try {
      var stored = global.sessionStorage.getItem('lunaGiftCelebration');
      if (!stored) return;
      global.sessionStorage.removeItem('lunaGiftCelebration');
      var types = JSON.parse(stored);
      var config = readConfig();
      if (Array.isArray(types) && config) global.setTimeout(function () { showCelebration(types, config); }, 380);
    } catch (error) {}
  }

  function isCartPage() {
    return global.themeVariables && global.themeVariables.settings && global.themeVariables.settings.pageType === 'cart';
  }

  async function reconcile(options) {
    options = options || {};
    if (syncing) {
      rerunRequested = true;
      return false;
    }

    var config = readConfig();
    if (!config) return false;

    syncing = true;
    document.documentElement.dataset.lunaGiftSyncing = 'true';
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    var addedTypes = [];

    try {
      var cart = lastCart || await fetchCart();
      config.eligibleCents = computeEligibleCents(cart, config);
      updateProgressCards(config, cart);
      var plan = computeGiftPlan(cart, config);
      if (!plan.hasChanges) return false;

      if (Object.keys(plan.updates).length) {
        cart = await updateLines(plan.updates);
      }

      if (plan.additions.length) {
        cart = await addItems(plan.additions);
        addedTypes = plan.additions.map(function (item) { return item.properties[PROPERTY_KEY]; });
      }

      lastCart = cart;
      if (addedTypes.length) persistCelebration(addedTypes);

      if (isCartPage() && !options.beforeCheckout) {
        global.location.reload();
        return true;
      }

      dispatchCartChange(cart, addedTypes.length ? 'luna-gift:add' : 'luna-gift:normalize');
      if (addedTypes.length) {
        try { global.sessionStorage.removeItem('lunaGiftCelebration'); } catch (error) {}
        global.setTimeout(function () { showCelebration(addedTypes, config); }, 260);
      }
      return true;
    } catch (error) {
      console.error('[Luna Gift Controller]', error);
      showSyncError('Hediye eklenemedi — sepeti yenileyip tekrar dene.');
      announce('Hediye sepete otomatik eklenemedi. Lütfen sepeti yenileyin.');
      return false;
    } finally {
      syncing = false;
      document.documentElement.removeAttribute('data-luna-gift-syncing');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      if (rerunRequested) {
        rerunRequested = false;
        scheduleSync('rerun', 220);
      }
    }
  }

  function scheduleSync(reason, delay) {
    global.clearTimeout(syncTimer);
    syncTimer = global.setTimeout(function () { reconcile({ reason: reason }); }, typeof delay === 'number' ? delay : 160);
  }

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) lastCart = event.detail.cart;
    scheduleSync('cart-change', event.detail && String(event.detail.baseEvent || '').indexOf('luna-gift:') === 0 ? 500 : 220);
  });
  document.addEventListener('cart:refresh', function () { lastCart = null; scheduleSync('cart-refresh', 260); });
  document.addEventListener('cart-drawer:refreshed', function () { scheduleSync('drawer-refreshed', 60); });
  global.addEventListener('pageshow', function () { lastCart = null; scheduleSync('pageshow', 120); });
  global.addEventListener('focus', function () { scheduleSync('focus', 180); });

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    var form = event.target;
    var isCheckout = submitter && submitter.name === 'checkout' && form && form.matches('form[action*="/cart"]');
    if (!isCheckout || checkoutPending) return;
    event.preventDefault();
    checkoutPending = true;
    submitter.setAttribute('aria-busy', 'true');
    reconcile({ beforeCheckout: true }).finally(function () {
      var checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      form.appendChild(checkoutInput);
      HTMLFormElement.prototype.submit.call(form);
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      consumeCelebration();
      scheduleSync('dom-ready', 60);
    }, { once: true });
  } else {
    consumeCelebration();
    scheduleSync('immediate', 40);
  }
})(typeof window !== 'undefined' ? window : null);
